import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React from 'react';
import { LayoutWithUserNav } from '@members/layout/containers';

const WorkoutDetails = dynamic(
  () => import('@members/pg-workouts/workout-details/WorkoutDetails'),
  {
    ssr: false,
  },
);

export default function WorkoutDetailsPage() {
  const router = useRouter();
  const workoutId = router.query?.workoutId as string;
  return (
    <LayoutWithUserNav>
      <WorkoutDetails workoutId={workoutId} />
    </LayoutWithUserNav>
  );
}
